import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../../config/api";

import "./../Styles/Dashboard.css";
import DateFilter from "../../Admin/Pages/DateFilter";

export default function Dashboard() {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 15; // you can change to 10 if needed
  const [roles, setRoles] = useState([]);
  const [supplierTypes, setSupplierTypes] = useState([]);
  const [user, setUser] = useState("");
  const [orders, setOrders] = useState([]); // State for managing designer specific orders

  const [serverCharge, setServerCharge] = useState(0);
  const [serverMessage, setServerMessage] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [allSupplierTypes, setAllSupplierTypes] = useState([]);

  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");

  const [stats, setStats] = useState({
    machines: 0,
    designers: 0,
    workspace: 0,
    work_requests: 0,
    hiring_ads: 0,

    supplier_counts: {},

    total_designs: 0,
    today_uploads: 0,
    monthly_limit: 0,
    total_sales: 0,
    total_revenue: 0,
    commission_ratio: 0,
    commission_amount: 0,
    seller_earnings: 0,
    popular_designs: [],
    monthly_sales: [],
    latest_designs: [],
    recent_sales: [],
  });
  useEffect(() => {
    const loadServerCharge = async () => {
      try {
        const res = await fetch(
          `${API.BASE_URL}/payment.php?action=server_charge_amount`,
        );

        const data = await res.json();

        if (data.success) {
          setServerCharge(Number(data.amount));
        }
      } catch (err) {
        console.log(err);
      }
    };

    loadServerCharge();
  }, []);
  const fetchSupplierTypes = async () => {
    try {
      const res = await fetch(`${API.BASE_URL}/api.php?action=supplier_types`);
      const data = await res.json();

      if (data.status) {
        setAllSupplierTypes(data.data);
      }
    } catch (err) {
      console.log("Supplier type error", err);
    }
  };
  useEffect(() => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));
    if (!loginUser) return;

    setUser(loginUser.name);

    let options = loginUser.provider_options;
    if (typeof options === "string") {
      try {
        options = JSON.parse(options);
      } catch {
        options = options.split(",");
      }
    }
    setRoles(Array.isArray(options) ? options : []);

    let suppliers = loginUser.supplier_types;
    if (typeof suppliers === "string") {
      try {
        suppliers = JSON.parse(suppliers);
      } catch {
        suppliers = suppliers.split(",");
      }
    }
    setSupplierTypes(Array.isArray(suppliers) ? suppliers : []);

    fetchDashboard(loginUser.id);
    fetchDesignerOrders(loginUser.id);
    fetchSupplierTypes(); // Triggers contextual orders call
  }, []);

  const fetchDashboard = async (userId, from = "", to = "") => {
    try {
      let dashboardUrl = `${API.USER_DASHBOARD}&user_id=${userId}`;

      if (from) dashboardUrl += `&from_date=${from}`;
      if (to) dashboardUrl += `&to_date=${to}`;

      const res = await fetch(dashboardUrl);
      const userData = await res.json();

      const d = userData.design_dashboard || {};

      setStats({
        machines: Number(userData.machines?.total || 0),

        designers: Number(userData.designers?.total || 0),

        workspace: Number(userData.workspaces?.total || 0),
        hiring_ads: Number(userData.hiring_ads?.total || 0),
        supplier_counts: Object.fromEntries(
          (userData.suppliers || []).map((item) => [
            item.type.toLowerCase(),
            Number(item.total),
          ]),
        ),

        total_designs: Number(d.total_designs || 0),

        today_uploads: Number(d.today_uploads || 0),

        monthly_limit: Number(d.monthly_limit || 0),

        total_sales: Number(d.total_sales || 0),

        total_revenue: Number(d.total_revenue || 0),
        work_requests: Number(userData.work_requests?.total || 0),
        commission_ratio: Number(d.commission_ratio || 0),

        commission_amount: Number(d.commission_amount || 0),

        seller_earnings: Number(d.seller_earnings || 0),

        popular_designs: [],

        monthly_sales: [],

        latest_designs: [],

        recent_sales: [],
      });
    } catch (err) {
      console.log(err);
    }
  };

  const fetchDesignerOrders = async (userId, from = "", to = "") => {
    try {
      let url = `${API.GET_DESIGNER_ORDERS}&user_id=${userId}`;

      if (from) url += `&from_date=${from}`;
      if (to) url += `&to_date=${to}`;

      const res = await fetch(url);
      const data = await res.json();

      if (data.success) {
        setOrders(data.orders || []);
        setCurrentPage(1);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const suppliers = supplierTypes.map((x) => x.trim().toLowerCase());
  const canMachine = roles.includes("machines");
  const canDesigner = roles.includes("designers");
  const canWorkspace = roles.includes("workspaces");
  const canSellDesigns = roles.includes("designs");

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  const currentOrders = orders.slice(indexOfFirstRecord, indexOfLastRecord);

  const totalPages = Math.ceil(orders.length / recordsPerPage);
  useEffect(() => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));
    if (!loginUser) return;

    // Load all orders when both dates are empty
    if (!fromDate && !toDate) {
      fetchDesignerOrders(loginUser.id);
      return;
    }

    // Filter only when both dates are selected
    if (fromDate && toDate) {
      fetchDesignerOrders(loginUser.id, fromDate, toDate);
    }
  }, [fromDate, toDate]);

  const totalEarnings = orders.reduce(
    (sum, o) => sum + Number(o.designer_earnings || 0),
    0,
  );

  const paidAmount = orders.length ? Number(orders[0].paid_amount || 0) : 0;

  const pendingAmount = totalEarnings - paidAmount;

  const payServerCharge = async () => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));

    if (!loginUser) return;

    const res = await fetch(
      `${API.BASE_URL}/payment.php?action=create_server_charge_order`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: loginUser.id,
        }),
      },
    );

    const data = await res.json();

    if (!data.success) {
      alert(data.message);
      return;
    }

    const options = {
      key: data.key,

      amount: data.amount,

      currency: "INR",

      name: "Server Charges",

      description: "Designer Server Charges",

      order_id: data.order_id,

      handler: function (response) {
        saveServerPayment(response);
      },

      modal: {
        ondismiss: function () {
          saveCancelledPayment(data.order_id);
        },
      },

      prefill: {
        name: data.name,
        email: data.email,
        contact: data.phone,
      },

      theme: {
        color: "#0d51cf",
      },
    };

    const razor = new window.Razorpay(options);

    razor.on("payment.failed", function () {
      setServerMessage("Payment failed. Please try again.");
    });

    razor.open();
  };

  const saveServerPayment = async (response) => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));

    const res = await fetch(
      `${API.BASE_URL}/payment.php?action=verify_server_charge_payment`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          razorpay_payment_id: response.razorpay_payment_id,

          razorpay_order_id: response.razorpay_order_id,

          user_id: loginUser.id,
        }),
      },
    );

    const data = await res.json();

    if (data.success) {
      setServerMessage("Server charge payment successful.");
    } else {
      setServerMessage("Payment verification failed.");
    }
  };

  const saveCancelledPayment = async (order_id) => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));

    await fetch(`${API.BASE_URL}/payment.php?action=cancel_server_charge`, {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify({
        user_id: loginUser.id,

        order_id,
      }),
    });

    setServerMessage("Payment cancelled by user.");
  };

  return (
    <div className="dashboard-page">
      <div className="container-fluid">
        <div className="dashboard-top mb-0">
          <div className="header-info">
            <h2>Welcome Back 👋</h2>
            <p className="username">{user}</p>
          </div>

          <div className="d-flex gap-2">
            {canSellDesigns && (
              // <button className="btn btn-success" onClick={payServerCharge}>
              //   Pay Server Charges ₹{serverCharge}
              // </button>
              <button
                className="btn btn-success"
                onClick={() => setShowPaymentModal(true)}
              >
                Pay Server Charges ₹{serverCharge}
              </button>
            )}

            <button className="customer-btn" onClick={() => navigate("/")}>
              Website Visit
            </button>
          </div>
        </div>
        {serverMessage && (
          <div className="alert alert-info mt-3">{serverMessage}</div>
        )}

        {/* ================= SUMMARY CARDS ================= */}
        <div className="userstat-grid">
          {canMachine && (
            <div>
              <div
                className="db-card machine-card"
                onClick={() => navigate("/user/add-machine")}
              >
                <div className="db-card-icon">
                  <i className="bi bi-cpu"></i>
                </div>
                <div>
                  <h6>Machines</h6>
                  <h2>{stats.machines}</h2>
                </div>
              </div>
            </div>
          )}

          {canDesigner && (
            <div>
              <div
                className="db-card machine-card"
                onClick={() => navigate("/user/add-designer")}
              >
                <div className="db-card-icon">
                  <i className="bi bi-person-workspace"></i>
                </div>
                <div>
                  <h6>Designers</h6>
                  <h2>{stats.designers}</h2>
                </div>
              </div>
            </div>
          )}

          {canWorkspace && (
            <div>
              <div
                className="db-card machine-card"
                onClick={() => navigate("/user/add-workspace")}
              >
                <div className="db-card-icon">
                  <i className="bi bi-building"></i>
                </div>
                <div>
                  <h6>Workspaces</h6>
                  <h2>{stats.workspace}</h2>
                </div>
              </div>
            </div>
          )}
          {roles.includes("job_worker") && (
            <div>
              <div
                className="db-card machine-card"
                onClick={() => navigate("/user/add-work")}
              >
                <div className="db-card-icon">
                  <i className="bi bi-briefcase"></i>
                </div>

                <div>
                  <h6>Total Added Work</h6>
                  <h2>{stats.work_requests}</h2>
                </div>
              </div>
            </div>
          )}
          {roles.includes("job_worker") && (
            <div>
              <div
                className="db-card machine-card"
                onClick={() => navigate("/user/hiring-ads")}
              >
                <div className="db-card-icon">
                  <i className="bi bi-megaphone"></i>
                </div>

                <div>
                  <h6>Hiring Ads</h6>
                  <h2>{stats.hiring_ads}</h2>
                </div>
              </div>
            </div>
          )}
          {allSupplierTypes.map((supplier) => {
            const key = supplier.type;

            const userHasSupplier = suppliers.includes(key);

            if (!userHasSupplier) return null;

            return (
              <div key={supplier.id}>
                <div
                  className="db-card machine-card"
                  onClick={() => navigate(`/user/${key}`)}
                >
                  <div className="db-card-icon">
                    <i className="bi bi-shop"></i>
                  </div>

                  <div>
                    <h6>{supplier.display_name}</h6>

                    <h2>{stats.supplier_counts[key] || 0}</h2>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* ================= DESIGN SELLER SUMMARY ================= */}
        {canSellDesigns && (
          <>
            <div className="orders-filter-card mb-0">
              <div
                className="orders-filter-body"
                style={{ justifyContent: "end" }}
              >
                <DateFilter
                  fromDate={fromDate}
                  toDate={toDate}
                  setFromDate={(from) => {
                    setFromDate(from);

                    const loginUser = JSON.parse(
                      sessionStorage.getItem("user"),
                    );
                    if (!loginUser) return;

                    fetchDashboard(loginUser.id, from, toDate);
                    fetchDesignerOrders(loginUser.id, from, toDate);
                  }}
                  setToDate={(to) => {
                    setToDate(to);

                    const loginUser = JSON.parse(
                      sessionStorage.getItem("user"),
                    );
                    if (!loginUser) return;

                    fetchDashboard(loginUser.id, fromDate, to);
                    fetchDesignerOrders(loginUser.id, fromDate, to);
                  }}
                />
              </div>
            </div>

            <div className="analytics-grid1 w-100 m-0">
              <div className="mini-card combined-card">
                <small style={{ color: "#f2f4f7" }}>
                  Total Earnings Overview
                </small>

                {/* <h2>₹{totalEarnings.toLocaleString()}</h2> */}
                <h2 style={{ color: "#f2f4f7", textAlign: "center" }}>
                  ₹{pendingAmount.toLocaleString()}
                </h2>
              </div>

              {/* MINI STATS */}
              <div className="mini-cards">
                <div className="mini-card">
                  <small>Total Orders</small>
                  <h3>{stats.total_sales}</h3>
                </div>

                <div className="mini-card">
                  <small>Total Revenue</small>
                  <h3>₹{Number(stats.total_revenue).toLocaleString()}</h3>
                </div>
                <div className="mini-card danger">
                  <small>Current Commission</small>

                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <h3 style={{ textAlign: "center" }}>
                      {stats.commission_ratio}%
                    </h3>
                  </div>
                </div>
                <div className="mini-card danger">
                  <small>Platform Commission</small>

                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <h3 style={{ textAlign: "center" }}>
                      ₹{Number(stats.commission_amount).toLocaleString()}
                    </h3>
                  </div>
                </div>

                {/* <div className="mini-card success">
                  <small>Designs Upload</small>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {" "}
                    <h3>{stats.total_designs}</h3>
                    <small>{stats.monthly_limit} Limit</small>
                  </div>
                 
                  
                </div> */}

                <div className="mini-card success">
                  <small>Paid Amount</small>

                  <h3 style={{ textAlign: "center" }}>
                    ₹{paidAmount.toLocaleString()}
                  </h3>
                  {/* <small>{stats.monthly_limit} Limit</small> */}

                  {/* 
                  <div className="progress mt-3">
                    <div
                      className="progress-bar bg-success"
                      style={{ width: `${uploadPercent}%` }}
                    ></div>
                  </div> */}
                </div>
              </div>
            </div>
            {/* ================= CUSTOM DESIGNER ORDERS TABLE ================= */}
            <div className="orders-section mt-4">
              <h3 className="section-title mb-4">Your Design Orders</h3>
              <div className="orders-table-wrapper">
                {orders.length === 0 ? (
                  <div className="no-orders-alert">
                    No orders found for your designs yet.
                  </div>
                ) : (
                  <table className="table custom-dashboard-table">
                    <thead>
                      <tr>
                        <th>Order No</th>
                        <th>Date & Time</th>

                        <th>Price</th>
                        <th>Commission</th>
                        <th>Net Earnings</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {currentOrders.map((order) => (
                        <tr key={order.id}>
                          <td>
                            <strong>{order.order_no}</strong>
                          </td>

                          <td>
                            <div>{order.order_date}</div>
                            <small className="text-muted">
                              {order.order_time}
                            </small>
                          </td>

                          <td>
                            <span
                              className={`fw-bold ${
                                order.status?.toLowerCase() === "confirmed"
                                  ? "text-success"
                                  : "text-muted text-decoration-line-through"
                              }`}
                            >
                              ₹{Number(order.designer_total).toLocaleString()}
                            </span>
                          </td>

                          <td>
                            <div className="fw-bold text-danger">
                              ₹
                              {Number(order.commission_amount).toLocaleString()}
                            </div>
                            <small className="text-muted">
                              {order.commission_ratio}%
                            </small>
                          </td>

                          <td>
                            <span className="fw-bold text-success">
                              ₹
                              {Number(order.designer_earnings).toLocaleString()}
                            </span>
                          </td>

                          <td>
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() =>
                                navigate("/user/order-details", {
                                  state: {
                                    ...order,
                                    fromDesigner: true,
                                  },
                                })
                              }
                            >
                              View Order
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
                {totalPages > 1 && (
                  <div className="ad-pagination-container mt-3 d-flex justify-content-between align-items-center">
                    <button
                      className="ad-page-btn"
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage((p) => p - 1)}
                    >
                      ← Previous
                    </button>

                    <span className="ad-page-info">
                      Page <strong>{currentPage}</strong> of {totalPages}
                    </span>

                    <button
                      className="ad-page-btn"
                      disabled={currentPage === totalPages}
                      onClick={() => setCurrentPage((p) => p + 1)}
                    >
                      Next →
                    </button>
                  </div>
                )}
              </div>
            </div>
          </>
        )}

        {showPaymentModal && (
          <div className="payment-modal-overlay">
            <div className="payment-modal-box p-4">
              <div className="ad-modal-header pb-1 mb-1">
                <h4 className="mb-0">Select Payment Method</h4>

                <button
                  className="btn-close-custom"
                  onClick={() => {
                    setShowPaymentModal(false);
                    setPaymentMethod("");
                  }}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: "center",
                }}
              >
                <button
                  className="btn btn-light p-0"
                  onClick={() => setPaymentMethod("gpay")}
                >
                  <img
                    src="/images/gpay.png"
                    alt="Google Pay"
                    style={{ width: "120px", height: "60px" }}
                  />
                </button>
                <button
                  className="btn btn-light p-1"
                  onClick={() => {
                    setShowPaymentModal(false);
                    payServerCharge();
                  }}
                >
                  <img
                    src="/images/razorpay.png"
                    alt="Razorpay"
                    style={{ width: "120px", height: "60px" }}
                  />
                </button>
              </div>
              {paymentMethod === "gpay" && (
                <div className="text-center mt-4">
                  <p className="mt-3 fw-bold" style={{ fontSize: "13px" }}>
                    Scan using Google Pay
                  </p>
                  <img
                    src="/images/qr.jpeg"
                    alt="Google Pay QR"
                    className="payment-qr"
                  />
                  <p className="mt-3 fw-bold">
                    Amount: <strong>₹{serverCharge}</strong>
                  </p>

                  <p className="mt-3 text-danger fw-bold">
                    After Payment Send Screenshot And Call on +91 9909614445
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
